import React from 'react';
import { StarIcon } from 'lucide-react';
type Testimonial = {
  quote: string;
  name: string;
  role: string;
  image: string;
  imageAlt: string;
};
const first: Testimonial[] = [{
  quote: 'Organicé todo mi año en una tarde. Nunca volví a planificar el domingo.',
  name: 'Mariela G., Colombia',
  role: 'Maestra de Primaria',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/1b7f9674-0cd8-435f-bdaa-01b565be1102.jpg',
  imageAlt: 'Retrato de Mariela G.'
}, {
  quote: 'Entré al aula sin materiales y salí con una clase brillante. El Tomo 3 me salvó.',
  name: 'Laura P., México',
  role: 'Docente de Secundaria',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/356d0d8e-e26e-492a-9d21-3d467c5bb7e1.jpg',
  imageAlt: 'Retrato de Laura P.'
}, {
  quote: 'El viernes salgo sin un solo cuaderno en la mochila.',
  name: 'Rosa M., Argentina',
  role: 'Maestra de Primaria',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/9ab5e5e8-591e-4f6f-ac6c-af87d73c7867.jpg',
  imageAlt: 'Retrato de Rosa M.'
}];
const second: Testimonial[] = [{
  quote: 'Entré el lunes con el Tomo 3 y nadie notó que no tenía plan. Eso no me había pasado nunca.',
  name: 'Claudia R. · 📍 Bogotá, Colombia',
  role: '',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/ca90fc11-497f-4233-94d0-53d14eb34822.jpg',
  imageAlt: 'Retrato de Claudia R.'
}, {
  quote: 'El viernes califiqué con el Tomo 6 durante la clase. Salí a las 2 PM sin nada en la mochila.',
  name: 'Sofía C. · 📍 Lima, Perú',
  role: '',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/081f999b-5f8d-4514-9968-4e647589a83a.jpg',
  imageAlt: 'Retrato de Sofía C.'
}, {
  quote: 'Mi grupo instala las rutinas del Tomo 5 en dos semanas. Ahora entran solos y empiezan solos.',
  name: 'Patricia A. · 📍 Guadalajara, México',
  role: '',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/a0681539-bad6-45ae-8f3f-5b83d058385c.jpg',
  imageAlt: 'Retrato de Patricia A.'
}, {
  quote: 'De 5 horas los domingos a 25 minutos. Ese fue mi resultado en la primera semana.',
  name: 'Jorge M. · 📍 Santiago, Chile',
  role: '',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/cf298029-6bb9-4b59-a748-eb5a31719720.jpg',
  imageAlt: 'Retrato de Jorge M.'
}];
function Stars() {
  return <div className="flex gap-0.5 text-yellow-400" aria-label="5 de 5 estrellas" data-id="element-200" data-mp="19rdbwf0a4o7c">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-201" data-mp="14qz32uquta89" data-mpi={i} />)}
    </div>;
}
function Card({
  t
}: {
  t: Testimonial;
}) {
  return <figure className="flex h-full flex-col rounded-2xl border border-navy/10 bg-white p-5 shadow-card" data-id="element-202" data-mp="vrc2gb5y88g9">
      <div className="mb-3 flex items-center gap-3" data-id="element-203" data-mp="qu2fr39y2aw4">
        <img src={t.image} alt={t.imageAlt} className="h-12 w-12 shrink-0 rounded-full border-2 border-white object-cover shadow-sm" data-id="element-204" data-mp="32h5wg9iuivla" />
        <Stars data-id="element-205" data-mp="37i3bid8k79ik" />
      </div>
      <blockquote className="flex-1 text-[15px] leading-relaxed text-navy/80" data-id="element-206" data-mp="3cfd3o0nc1za3">
        “{t.quote}”
      </blockquote>
      <figcaption className="mt-4 border-t border-navy/10 pt-3" data-id="element-207" data-mp="3ggyme2mjt7s7">
        <div className="text-sm font-bold text-navy" data-id="element-208" data-mp="2jqeieunwyh0k">{t.name}</div>
        {t.role && <div className="text-xs text-navy/55" data-id="element-209" data-mp="2jobhvgp4x5hl">{t.role}</div>}
      </figcaption>
    </figure>;
}
export function Testimonials({
  title,
  variant = 'first'
}: {
  title: string;
  variant?: 'first' | 'second';
}) {
  const items = variant === 'first' ? first : second;
  return <section className="bg-cream px-4 py-14" data-id="element-210" data-mp="2xjdvkq083z4y">
      <div className="mx-auto max-w-4xl" data-id="element-211" data-mp="2106i0kblm4o2">
        <h2 className="mb-8 text-center font-display text-2xl font-black uppercase tracking-tight text-navy sm:text-3xl" data-id="element-212" data-mp="20z57qi2epm7e">
          {title}
        </h2>
        <div className="grid gap-4 sm:grid-cols-2" data-id="element-213" data-mp="1lwwre6a7vans">
          {items.map(t => <Card key={t.name} t={t} data-id="element-214" data-mp="1luk89psq2u95" />)}
        </div>
      </div>
    </section>;
}